import axios from "axios";
import { createContext, useContext } from "react";

const BrandContext = createContext(null);
const host: string = import.meta.env.VITE_BACKEND_SERVER_URL;

export const useBrand = () => {
  return useContext(BrandContext);
};

export const BrandProvider = (props) => {
  //UpdateBrandInfo
  const updateBrand = async (data) => {
    try {
      const response = await axios.post(
        `${host}/Brand/updateBrandData`,
        { ...data },
        {
          headers: {
            jwtToken: localStorage.getItem("jwtToken"),
          },
        }
      );
      if (response.status !== 200) {
        return { Error: response.data.error };
      } else {
        return response.data;
      }
    } catch (e) {
      return { Error: e.response.data.error };
    }
  };
  const UpdateBrandInfo = async (data) => {
    try {
      const response = await axios.post(
        `${host}/Brand/info`,
        { ...data },
        {
          headers: {
            jwtToken: localStorage.getItem("jwtToken"),
          },
        }
      );
      if (response.status !== 200) {
        return { Error: response.data.error };
      } else {
        return response.data;
      }
    } catch (e) {
      return { Error: e.response.data.error };
    }
  };
  //UpdateBrandMarketing
  const UpdateBrandMarketingInfo = async (data) => {
    try {
      const response = await axios.post(
        `${host}/Brand/marketingInfo`,
        { ...data },
        {
          headers: {
            jwtToken: localStorage.getItem("jwtToken"),
          },
        }
      );
      if (response.status !== 200) {
        return { Error: response.data.error };
      } else {
        return response.data;
      }
    } catch (e) {
      return { Error: e.response.data.error };
    }
  };
  const SaveContactNumber = async (companyPhoneNumber) => {
    try {
      const response = await axios.post(
        `${host}/Brand/companyPhoneNumber`,
        { companyPhoneNumber },
        {
          headers: {
            jwtToken: localStorage.getItem("jwtToken"),
          },
        }
      );
      if (response.status !== 200) {
        return { Error: response.data.error };
      } else {
        return response.data;
      }
    } catch (e) {
      return { Error: e.response.data.error };
    }
  };
  const getBrandInfo = async () => {
    try {
      const response = await axios.get(`${host}/Brand/info`, {
        headers: {
          jwtToken: localStorage.getItem("jwtToken"),
        },
      });

      // Check if the response contains the LinkedIn authorization URL
      if (response.status !== 200) {
        return { Error: response.data.error };
      } else {
        return response.data;
      }
    } catch (error) {
      return { Error: error.response.data.error };
    }
  };
  const getBrandMarketingInfo = async () => {
    try {
      const response = await axios.get(`${host}/influencer/marketingInfo`, {
        headers: {
          jwtToken: localStorage.getItem("jwtToken"),
        },
      });

      // Check if the response contains the LinkedIn authorization URL
      if (response.status !== 200) {
        throw new Error("Error in getting the data");
      } else {
        return response.data;
      }
    } catch (error) {
      alert(error);
    }
  };
  const getAllInfluencersData = async (
    startIndex,
    limit,
    selectedAudienceTypeFilters,
    selectedContentTypeFilters,
    selectedCollaboratedWithBrand,
    selectedFollowersFilters,
    selectedGenderFilters,
    selectedMonetizationFilters,
    selectedPaidAudienceFilters,
    selectedCollaboratedWithFilters,
    selectedCampaignGoalsFilters,
    selectedLocationFilters,
    selectedCrossPlatformFilters
  ) => {
    try {
      const response = await axios.post(
        `${host}/Brand/getAllInfluencers?startIndex=${startIndex}&limit=${limit}`,
        {
          selectedAudienceTypeFilters,
          selectedContentTypeFilters,
          selectedCollaboratedWithBrand,
          selectedFollowersFilters,
          selectedGenderFilters,
          selectedMonetizationFilters,
          selectedPaidAudienceFilters,
          selectedCollaboratedWithFilters,
          selectedCampaignGoalsFilters,
          selectedLocationFilters,
          selectedCrossPlatformFilters,
        },
        {
          headers: {
            jwtToken: localStorage.getItem("jwtToken"),
          },
        }
      );

      // Check if the response contains the LinkedIn authorization URL
      if (response.status !== 200) {
        return { Error: response.data.error };
      } else {
        return response.data;
      }
    } catch (error) {
      return { Error: error.response.data.error };
    }
  };
  const getInfluencerWithCredits = async (influencerID, withUrl) => {
    try {
      const response = await axios.post(
        `${host}/Brand/getInfluencer/${influencerID}/${withUrl}`,
        {},
        {
          headers: {
            jwtToken: localStorage.getItem("jwtToken"),
          },
        }
      );
      if (response.status !== 200) {
        return { Error: response.data.error };
      } else {
        return response.data;
      }
    } catch (error) {
      return { Error: error.response.data.error };
    }
  };
  const getUnlockedInfluencers = async () => {
    try {
      const response = await axios.get(`${host}/Brand/getUnlockedInfluencers`, {
        headers: {
          jwtToken: localStorage.getItem("jwtToken"),
        },
      });
      if (response.status !== 200) {
        return { Error: response.data.error };
      } else {
        return response.data;
      }
    } catch (e) {
      return { Error: e.response.data.error };
    }
  };
  const getCreditsHistory = async () => {
    try {
      const response = await axios.get(`${host}/Brand/getCreditsHistory`, {
        headers: {
          jwtToken: localStorage.getItem("jwtToken"),
        },
      });
      if (response.status !== 200) {
        return { Error: response.data.error };
      } else {
        return response.data;
      }
    } catch (e) {
      return { Error: e.response.data.error };
    }
  };
  const getInfluencerPersonalInfo = async (InfluencerID: string) => {
    try {
      const response = await axios.get(
        `${host}/Brand/getInfluencerPersonalData/${InfluencerID}`,
        {
          headers: {
            jwtToken: localStorage.getItem("jwtToken"),
          },
        }
      );

      // Check if the response contains the LinkedIn authorization URL
      if (response.status !== 200) {
        return { Error: response.data.error };
      } else {
        return response.data;
      }
    } catch (e) {
      return { Error: e.response.data.error };
    }
  };
  const getInfluencerPersonalInfoBySlug = async (slug: string) => {
    try {
      const response = await axios.get(
        `${host}/Brand/getInfluencerPersonalDataBySlug/${slug}`,
        {
          headers: {
            jwtToken: localStorage.getItem("jwtToken"),
          },
        }
      );

      // Check if the response contains the LinkedIn authorization URL
      if (response.status !== 200) {
        return { Error: response.data.error };
      } else {
        return response.data;
      }
    } catch (e) {
      return { Error: e.response.data.error };
    }
  };
  const getInfluencerPersonalInfoByName = async (slug: string) => {
    try {
      const response = await axios.get(
        `${host}/Brand/getInfluencerPersonalDataByName/${slug}`,
        {
          headers: {
            jwtToken: localStorage.getItem("jwtToken"),
          },
        }
      );

      // Check if the response contains the LinkedIn authorization URL
      if (response.status !== 200) {
        return { Error: response.data.error };
      } else {
        return response.data;
      }
    } catch (e) {
      return { Error: e.response.data.error };
    }
  };

  //subscription plans
  const getSubscriptionPlans = async () => {
    try {
      const response = await axios.get(
        `${host}/brand/Subscription/getAllPlan`,
        {
          headers: {
            jwtToken: localStorage.getItem("jwtToken"),
          },
        }
      );
      if (response.status !== 200) {
        return { Error: response.data.error };
      } else {
        return response.data;
      }
    } catch (e) {
      return { Error: e.response.data.error };
    }
  };
  const getSubscriptionPlanById = async (planID) => {
    try {
      const response = await axios.get(
        `${host}/brand/Subscription/getPlanById`,
        {
          params: {
            planID,
          },
          headers: {
            jwtToken: localStorage.getItem("jwtToken"),
          },
        }
      );

      // Check if the response contains the LinkedIn authorization URL
      if (response.status !== 200) {
        return { Error: response.data.error };
      } else {
        return response.data;
      }
    } catch (e) {
      return { Error: e.response.data.error };
    }
  };
  const getCreditsStats = async () => {
    try {
      const response = await axios.get(
        `${host}/brand/Subscription/creditsStats`,
        {
          headers: {
            jwtToken: localStorage.getItem("jwtToken"),
          },
        }
      );
      if (response.status !== 200) {
        return { Error: response.data.error };
      } else {
        return response.data;
      }
    } catch (e) {
      return { Error: e.response.data.error };
    }
  };
  const getTransactionHistory = async () => {
    try {
      const response = await axios.get(
        `${host}/brand/Subscription/transaction-history`,
        {
          headers: {
            jwtToken: localStorage.getItem("jwtToken"),
          },
        }
      );
      if (response.status !== 200) {
        return { Error: response.data.error };
      } else {
        return response.data;
      }
    } catch (e) {
      return { Error: e.response.data.error };
    }
  };
  const getBrandRewardActivity = async () => {
    try {
      const response = await axios.get(
        `${host}/brand/Subscription/rewardActivity`,
        {
          headers: {
            jwtToken: localStorage.getItem("jwtToken"),
          },
        }
      );
      if (response.status !== 200) {
        return { Error: response.data.error };
      } else {
        return response.data;
      }
    } catch (e) {
      return { Error: e.response.data.error };
    }
  };
  const SendSecureOTP = async (phoneNumber) => {
    try {
      const response = await axios.post(
        `${host}/brand/send-otp`,
        { phoneNumber },
        {
          headers: {
            jwtToken: localStorage.getItem("jwtToken"),
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        return response.data;
      } else {
        return {
          success: false,
          error: response.data.error || "Failed to send OTP",
        };
      }
    } catch (error) {
      console.error("Send OTP error:", error);
      return {
        success: false,
        error: error.response?.data?.error || "Network error occurred",
      };
    }
  };
  const VerifySecureOTP = async (otp, phoneNumber) => {
    try {
      const response = await axios.post(
        `${host}/brand/verify-otp`,
        { otp, phoneNumber },
        {
          headers: {
            jwtToken: localStorage.getItem("jwtToken"),
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        return response.data;
      } else {
        return {
          success: false,
          error: response.data.error || "Verification failed",
        };
      }
    } catch (error) {
      console.error("Verify OTP error:", error);
      return {
        success: false,
        error: error.response?.data?.error || "Network error occurred",
        remainingAttempts: error.response?.data?.remainingAttempts,
      };
    }
  };
  const handlePlanUsageFromClient = async (data) => {
    try {
      const response = await axios.post(
        `${host}/brand/Subscription/clientUsage`,
        { ...data },
        {
          headers: {
            jwtToken: localStorage.getItem("jwtToken"),
          },
        }
      );
      if (response.status !== 200) {
        return { Error: response.data.error };
      } else {
        return response.data;
      }
    } catch (e) {
      return { Error: e.response.data.error };
    }
  };
  const checkPlanUsageFromClient = async ({ activity, influencerId }) => {
    try {
      const response = await axios.get(
        `${host}/brand/Subscription/clientUsage?activity=${activity}&influencerId=${influencerId}`,
        {
          headers: {
            jwtToken: localStorage.getItem("jwtToken"),
          },
        }
      );
      if (response.status !== 200) {
        return { Error: response.data.error };
      } else {
        return response.data;
      }
    } catch (e) {
      return { Error: e.response.data.error };
    }
  };

  // get Locked Creator Details By ID
  const getLockedCreatorDetailsByID = async (id) => {
    try {
      const response = await axios.get(
        `${host}/brand/getLockedCreatorDetails`,
        {
          headers: {
            jwtToken: localStorage.getItem("jwtToken"),
            searchCreator: id,
          },
        }
      );

      // Check if the response contains the LinkedIn authorization URL
      if (response.status !== 200) {
        return { Error: response.data.error };
      } else {
        return response.data;
      }
    } catch (e) {
      return { Error: e.response.data.error };
    }
  };

  //collab routes
  const saveCollabData = async (data) => {
    try {
      const res = await axios.post(
        `${host}/collabs/brand/createBrandCollabs`,
        data,
        {
          headers: {
            jwtToken: localStorage.getItem("jwtToken"),
          },
        }
      );

      if (res?.status === 200 && res?.data?.success) {
        return { success: true, data: res?.data };
      } else {
        return { success: false, data: res?.data };
      }
    } catch (error) {
      console.log(error);
      return { success: false, data: error };
    }
  };
  const toggleInfluencer = async (data) => {
    try {
      const response = await axios.post(`${host}/collabs/brand/toggle`, data, {
        headers: {
          jwtToken: localStorage.getItem("jwtToken"),
        },
      });
      if (response.status !== 200) {
        return { Error: response.data.error };
      } else {
        return response.data;
      }
    } catch (e) {
      return { Error: e.response.data.error };
    }
  };
  const getCollabData = async (collabId, sampleId) => {
    try {
      const response = await axios.get(
        `${host}/collabs/brand/getCollab/?collabId=${collabId}&sampleId=${
          sampleId ?? ""
        }`,
        {
          headers: {
            jwtToken: localStorage.getItem("jwtToken"),
          },
        }
      );
      if (response.status !== 200) {
        return { Error: response.data.error };
      } else {
        return response.data;
      }
    } catch (e) {
      return { Error: e.response.data.error };
    }
  };
  const getSampleCampaign = async () => {
    try {
      const response = await axios.get(
        `${host}/collabs/brand/getSampleCollab`,
        {
          headers: {
            jwtToken: localStorage.getItem("jwtToken"),
          },
        }
      );
      if (response.status !== 200) {
        return { Error: response.data.error };
      } else {
        return response.data;
      }
    } catch (e) {
      return { Error: e.response.data.error };
    }
  };
  const getLiveAndScheduledCollab = async () => {
    try {
      const response = await axios.get(
        `${host}/collabs/brand/getLiveAndScheduledCollab`,
        {
          headers: {
            jwtToken: localStorage.getItem("jwtToken"),
          },
        }
      );
      if (response.status !== 200) {
        return { Error: response.data.error };
      } else {
        return response.data;
      }
    } catch (e) {
      return { Error: e.response.data.error };
    }
  };

  const updateAnchorsCollabDetails = async (id: string, data: object) => {
    try {
      const response = await axios.post(
        `${host}/collab/brand/updateCollab/${id} `,
        data,
        {
          headers: {
            jwtToken: localStorage.getItem("jwtToken"),
          },
        }
      );
      if (response.status !== 200) {
        return { Error: response.data.error };
      } else {
        return response.data;
      }
    } catch (e) {
      return { Error: e.response.data.error };
    }
  };
  const uploadBrandCollabImage = async (data) => {
    try {
      const response = await axios.post(
        `${host}/upload/BrandCollabImageData`,
        data,
        {
          headers: {
            jwtToken: localStorage.getItem("jwtToken"),
          },
        }
      );

      // Check if the response contains the LinkedIn authorization URL
      if (response.status !== 200) {
        throw new Error("Error in saving the data");
      } else {
        return response.data;
      }
    } catch (error) {
      alert(error);
    }
  };
  const getCreatorForCollabByName = async (slug: string) => {
    try {
      const response = await axios.get(
        `${host}/collabs/brand/getCreatorForCollabByName/${slug}`,
        {
          headers: {
            jwtToken: localStorage.getItem("jwtToken"),
          },
        }
      );

      // Check if the response contains the LinkedIn authorization URL
      if (response.status !== 200) {
        return { Error: response.data.error };
      } else {
        return response.data;
      }
    } catch (e) {
      return { Error: e.response.data.error };
    }
  };
  const getInfluencerPersonalDataForCollabBySlug = async (slug: string) => {
    try {
      const response = await axios.get(
        `${host}/collabs/brand/getInfluencerPersonalDataBySlug/${slug}`,
        {
          headers: {
            jwtToken: localStorage.getItem("jwtToken"),
          },
        }
      );

      // Check if the response contains the LinkedIn authorization URL
      if (response.status !== 200) {
        return { Error: response.data.error };
      } else {
        return response.data;
      }
    } catch (e) {
      return { Error: e.response.data.error };
    }
  };
  const setPriceForInfluencer = async (data) => {
    try {
      const response = await axios.post(
        `${host}/collabs/brand/setPrice`,
        data,
        {
          headers: {
            jwtToken: localStorage.getItem("jwtToken"),
          },
        }
      );
      if (response.status !== 200) {
        return { Error: response.data.error };
      } else {
        return response.data;
      }
    } catch (e) {
      return { Error: e.response.data.error };
    }
  };
  const getCollabPostAnalysis = async (
    collabId,
    influencerId,
    refreshReport = false
  ) => {
    try {
      const endpoint = `${host}/collab/brands/${collabId}/postCampaignAnalysis/${influencerId}/${refreshReport}`;

      const response = await axios.get(endpoint, {
        headers: {
          jwtToken: localStorage.getItem("jwtToken"),
        },
      });
      if (response.status !== 200) {
        return { Error: response.data.error };
      } else {
        return response.data;
      }
    } catch (e) {
      return { Error: e.response.data.error };
    }
  };
  const getLivedDashboardData = async () => {
    try {
      const response = await axios.get(
        `${host}/collab/brand/getLivedDashboardData`,
        {
          headers: {
            jwtToken: localStorage.getItem("jwtToken"),
          },
        }
      );
      if (response.status !== 200) {
        return { Error: response.data.error };
      } else {
        return response.data;
      }
    } catch (e) {
      return { Error: e.response.data.error };
    }
  };
  const requestLatestDataFromInfluencer = async (data) => {
    try {
      const response = await axios.post(
        `${host}/collab/brand/request/influencerData`,
        data,
        {
          headers: {
            jwtToken: localStorage.getItem("jwtToken"),
          },
        }
      );
      if (response.status !== 200) {
        return { Error: response.data.error };
      } else {
        return response.data;
      }
    } catch (e) {
      return { Error: e.response.data.error };
    }
  };
  const fetchLatestDataFromInfluencer = async (data) => {
    try {
      const response = await axios.post(
        `${host}/collab/brand/fetch/influencerData`,
        data,
        {
          headers: {
            jwtToken: localStorage.getItem("jwtToken"),
          },
        }
      );
      if (response.status !== 200) {
        return { Error: response.data.error };
      } else {
        return response.data;
      }
    } catch (e) {
      return { Error: e.response.data.error };
    }
  };
  // post Tracking
  const updatePostTracking = async (
    collabId: string,
    postUrl: string,
    anchorsCollabId: string
  ) => {
    try {
      const response = await axios.get(
        `${host}/collab/brand/getPostTracking/?collabId=${collabId}&postUrl=${postUrl}&anchorsCollabId=${anchorsCollabId}`,
        {
          headers: {
            jwtToken: localStorage.getItem("jwtToken"),
          },
        }
      );

      if (response.status !== 200) {
        return { Error: response.data.error };
      } else {
        return response.data;
      }
    } catch (e) {
      return { Error: e.response.data.error };
    }
  };

  const submitCollabRating = async (data) => {
    try {
      const response = await axios.post(`${host}/collab/brand/rating`, data, {
        headers: {
          jwtToken: localStorage.getItem("jwtToken"),
        },
      });
      if (response.status !== 200) {
        return { Error: response.data.error };
      } else {
        return response.data;
      }
    } catch (e) {
      return { Error: e.response.data.error };
    }
  };
  // Get All Brand Payment Transactions
  const getBrandPaymentTransactions = async () => {
    try {
      const response = await axios.get(
        `${host}/brand/order/payment-transactions`,
        {
          headers: {
            jwtToken: localStorage.getItem("jwtToken"),
          },
        }
      );

      if (response.status !== 200) {
        return { Error: response.data.error };
      } else {
        return response.data;
      }
    } catch (e) {
      return { Error: e.response.data.error };
    }
  };
  const uploadBrandInvoices = async (data) => {
    try {
      const response = await axios.post(
        `${host}/upload/BrandInvoicesData`,
        data,
        {
          headers: {
            jwtToken: localStorage.getItem("jwtTokenD"),
          },
        }
      );

      // Check if the response contains the LinkedIn authorization URL
      if (response.status !== 200) {
        throw new Error("Error in saving the data");
      } else {
        return response.data;
      }
    } catch (error) {
      alert(error);
    }
  };

  const submitWantToCollabForm = async (data) => {
    try {
      const response = await axios.post(`${host}/brand/wantToCollab`, data, {
        headers: {
          jwtToken: localStorage.getItem("jwtToken"),
        },
      });
      if (response.status !== 200) {
        return { Error: response.data.error };
      } else {
        return response.data;
      }
    } catch (e) {
      return { Error: e.response.data.error };
    }
  };

  return (
    <BrandContext.Provider
      value={{
        updateBrand,
        UpdateBrandInfo,
        UpdateBrandMarketingInfo,
        SaveContactNumber,
        getBrandInfo,
        getBrandMarketingInfo,
        getAllInfluencersData,
        getInfluencerWithCredits,
        getUnlockedInfluencers,
        getCreditsHistory,
        getInfluencerPersonalInfo,
        getInfluencerPersonalInfoBySlug,
        getInfluencerPersonalInfoByName,
        getCreatorForCollabByName,

        //subscription plans
        getSubscriptionPlans,
        getSubscriptionPlanById,
        getCreditsStats,
        getTransactionHistory,
        getBrandRewardActivity,
        handlePlanUsageFromClient,
        checkPlanUsageFromClient,

        SendSecureOTP,
        VerifySecureOTP,
        getLockedCreatorDetailsByID,

        //collab
        saveCollabData,
        toggleInfluencer,
        getCollabData,
        getSampleCampaign,
        getLiveAndScheduledCollab,
        updateAnchorsCollabDetails,
        getInfluencerPersonalDataForCollabBySlug,
        updatePostTracking,
        uploadBrandCollabImage,
        getBrandPaymentTransactions,
        setPriceForInfluencer,
        uploadBrandInvoices,
        submitCollabRating,
        submitWantToCollabForm,
        getCollabPostAnalysis,
        getLivedDashboardData,
        requestLatestDataFromInfluencer,
        fetchLatestDataFromInfluencer,
      }}
    >
      {props.children}
    </BrandContext.Provider>
  );
};
